import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {ShowFilter, SortFilter} from "../ShopRatingSection";
import Select from "../../lib/form/Select/Select";
import styles from "./RatingFilter.module.scss"; // please consider to import styles as last to be able to override the styles in child components

export type RatingFilterState = {
  show: keyof typeof ShowFilter;
  sort: keyof typeof SortFilter;
};

type RatingFilterProps = {
  defaultState: RatingFilterState;
  onChange: (filterState: RatingFilterState) => void;
  filteredComments: number;
};

const RatingFilter: React.FC<RatingFilterProps> = ({onChange, filteredComments, defaultState}) => {
  const {t} = useTranslation();
  const [state, setState] = useState<RatingFilterState>(defaultState);

  useEffect(() => {
    onChange(state);
  }, [state]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.selectWrapper}>
        <span>{t("{{comments}} Bewertungen für", {comments: filteredComments})}</span>
        <Select
          styles={{wrapper: styles.select, optionsWrapper: styles.selectOptionsList}}
          value={state.show}
          onChange={(value) => {
            setState({...state, show: value as keyof typeof ShowFilter});
          }}
          options={[
            {text: t("Alle Varianten"), value: ShowFilter.all},
            {text: t("Ausgewählte Variante"), value: ShowFilter.one},
          ]}
        />
      </div>
      <div className={styles.selectWrapper}>
        <span>{t("Sortieren nach")}</span>
        <Select
          styles={{wrapper: `${styles.select} ${styles.sort}`, optionsWrapper: styles.selectOptionsList}}
          value={state.sort}
          onChange={(value) => {
            setState({...state, sort: value as keyof typeof SortFilter});
          }}
          options={[
            {text: t("Neueste"), value: SortFilter.newest},
            {text: t("Beste"), value: SortFilter.best},
            {text: t("Schlechteste"), value: SortFilter.worst},
          ]}
        />
      </div>
    </div>
  );
};

export default RatingFilter;
